'use strict';

export default class Search {
  constructor() {
    if ($('.path-search').length == 0) {
      return false;
    }

    const self = this;
    let queryParam = self.getParameterByName('search_api_fulltext');

    $('.path-search .views-field-search-api-excerpt .field-content:contains(' + queryParam + ')').html(function (_, html) {
      return html.split(queryParam).join('<strong><em>' + queryParam + '</em></strong>');
    });
  }

  getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }

    name = name.replace(/[\[\]]/g, '\\$&');

    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);

    if (!results) {
      return null;
    }

    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
